import proxy from './proxy';

let apiUrl = '';

const init = () => {
  apiUrl = proxy.endpoints.apiUrl;
};

export default class Api {
  static getProjects() {
    if (!apiUrl){
      init();
    }
    return proxy.http.get(apiUrl + '/api/Project/GetProjects');
  }

  static addProject(name: string, desc: string) {
    if (!apiUrl){
      init();
    }
    return proxy.http.post(apiUrl + '/api/Project/Add', {
      name: name,
      description: desc,
    });
  }

  static deleteProject(projectGUID: string) {
    if (!apiUrl){
      init();
    }
    return proxy.http.post(apiUrl + '/api/Project/Delete?projectGUID=' + projectGUID);
  }
}
